/** 规则维度：1=SPU，2=品类+大类 */
export const RULE_DIMENSION = {
    SPU: 1,
    CATEGORY: 2,
} as const;

/** 状态：1 启用 / 0 停用 */
export const RULE_STATUS = {
    ENABLED: 1,
    DISABLED: 0,
} as const;

export const RULE_DIMENSION_OPTIONS = [
    { value: RULE_DIMENSION.SPU, label: 'SPU' },
    { value: RULE_DIMENSION.CATEGORY, label: '品类+大类' },
];

export const RULE_STATUS_OPTIONS = [
    { value: RULE_STATUS.ENABLED, label: '启用' },
    { value: RULE_STATUS.DISABLED, label: '停用' },
];
